/**
 * Servicio que se encarga del manejo de las peticiones sobre las
 * acciones "Crear, Modificar y Eliminar" de Usuarios.
 * JMM-2018-10-25
 */
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { ConfigService } from '../../servicios/config/config.service';
import { KeyService } from '../../servicios/key.service';
import { Router, ActivatedRoute } from '@angular/router';

@Injectable()
export class UsuariosService {

  nitEmpresa        : any = localStorage.getItem('nitEmpresa');
  usuarioid         : any = localStorage.getItem('usuarioid');
  idusuario         : any = localStorage.getItem('idusuario');
  useringresoid     : any = localStorage.getItem('useringresoid');
  useringresoestado : any = localStorage.getItem('useringresoestado');

  PATH = new ConfigService().obtenerPath();

  constructor(
    private http    : Http,
    private _key    : KeyService,
    private router  : Router
  ) {}

  /**
   * Obtener listado de usuarios
   * JMM-2018-10-25
   */
  getUsuarios()
  {
    let url = this.PATH + '/api/admin/usuarios';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getUsuarios()


  //permite sincronizar los terceros de los usuarios del erp
  sincronizarUsarios()
  {
    let url = this.PATH + '/api/admin/sincronizarUsarios';
    return this.http.get(url,{headers:this._key.head()}).map(resp => resp.json());
  }

  getUsuarioActivos(){
    let url = this.PATH + '/api/admin/getUsuarioActivos';
    return this.http.get(url,{headers:this._key.head()}).map(resp => resp.json());
  }

  /**
   * Obtener un registro por id de una usuario para editar
   * JMM-2018-10-25
   */
  getRegUsuario(id:any)
  {
    let url = this.PATH + '/api/admin/usuarios/'+id+'/edit';
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getRegUsuario(id:any)

  /**
   * Enviar registros de usuarios
   * JMM-2018-10-25
   */
  setUsuarios(usuarios:any)
  {
    let url = this.PATH + '/api/admin/usuarios';
    return this.http.post(url, usuarios, {headers:this._key.head()}).map(resp => resp.json());
  }// .setUsuarios(usuarios:any)

    /**
   * Enviar registros de usuarios desde trcero
   * JMM-2018-10-25
   */
  usuarioscreate(usuarios:any)
  {
    let url = this.PATH + '/api/admin/usuarioscreate';
    return this.http.post(url, usuarios, {headers:this._key.head()}).map(resp => resp.json());
  }// .setUsuarios(usuarios:any)


  /**
   * Editar usuarios
   * JMM-2018-10-25
   */
  editUsuarios(usuarios:any)
  {
    let url = this.PATH+'/api/admin/usuarios/'+usuarios.id;
    return this.http.put(url, usuarios, {headers:this._key.head()}).map( resp => resp.json());
  }// .editUsuarios(usuarios:any)

  /**
   * Eliminar usuarios
   * JMM-2018-10-25
   */
  destroyUsuarios(data:any)
  {
    let url = this.PATH + '/api/admin/usuarios/eliminarUsuario';
    return this.http.post(url, data, { headers:this._key.head()}).map(resp => resp.json());
  }// .destroyUsuarios(data:any)

  /**
   * lista los usuarios segun el tipo
   * JMM-2018-10-25
   */
  getListUsuariosPorTipo(tipo)
  {
    let url = this.PATH + '/api/admin/listusuariosportipo/'+ tipo;
    return this.http.get(url, {headers: this._key.head()}).map(resp => resp.json());
  }// .getListUsuariosPorTipo(tipo)


  /**
   * Obtener filtro de usuarios
   * JMM-2018-12-10
   */
  getFiltroUsuarios(inform:any)
  {
    let usuarioid = inform.usuarioid != '' ? inform.usuarioid : null;
    let cedula    = inform.cedula    != '' ? inform.cedula    : null;
    let nombre    = inform.nombre    != '' ? inform.nombre    : null;
    let perfilid  = inform.perfilid  != '' ? inform.perfilid  : null;

    let url = this.PATH + '/api/admin/usuariosfiltros/'+usuarioid+'/'+cedula+'/'+nombre+'/'+perfilid;
    return this.http.get(url, {headers:this._key.head()}).map(resp => resp.json());
  }// .getFiltroUsuarios(id:any)


  /** Función que permite retornar los datos necesarios para la creación de un tercero
   * Nota: La url utilizada en esta función no entra al api.php va directamente a la función 'create' del controlador 'TerceroController.php'
   */
  getTipoUsuario()
  {
    let url = this.PATH + '/api/admin/listtipousuario';
    return this.http.get( url,{ headers: this._key.head() }).map(resp=>resp.json());
  }

  /**
   * Valida si el usuario se encuentra logueado
   * JMM-2019-04-02
   */
  getUserIngresado()
  {
    let url = this.PATH + '/api/obteneruseringresado/'+this.nitEmpresa+'/'+this.idusuario+'/'+this.useringresoid+'/'+this.useringresoestado;
    this.http.get(url, {headers:this._key.head()}).map(resp => resp.json()).subscribe((resp)=>{
      //Si devuelve un valor vacio cierra la sesión y se ubica en el login
      if (resp.data == 'salir')
      {
        localStorage.removeItem('PATH');
        localStorage.removeItem('usuarioid');
        localStorage.removeItem('clave');
        localStorage.removeItem('nombreUsuario');
        localStorage.removeItem('cedulaUsuario');
        localStorage.removeItem('idusuario');
        localStorage.removeItem('idperfil');
        localStorage.removeItem('estadonotificacion');
        localStorage.removeItem('nombreEmpresa');
        localStorage.removeItem('nitEmpresa');
        localStorage.removeItem('useringresoid');
        localStorage.removeItem('useringresoestado');
        localStorage.clear();
        this.router.navigate(['/login'], { replaceUrl: true });
        location.reload();
      }
    });
  }// .getUserIngresado()

  /**
   * Permite enviar la petición para actualizar los datos del ingreso del cliente al terminar la session
   * JMM-2019-04-02
   */
  salirsessioncliente(){
    let data = {
      'nitEmpresa': this.nitEmpresa,
      'idusuario' : this.idusuario
    }
    let url = this.PATH + '/api/salirsessioncliente';
    return this.http.post(url, data ,{headers:this._key.head()}).map(resp => resp.json());
  }// .salirsessioncliente()

  setTerceroSucursal(data){
    let url = this.PATH + '/api/admin/setTerceroSucursal';
    return this.http.post(url, data ,{headers:this._key.head()}).map(resp => resp.json());
  }// .salirsessioncliente()

  destroyTerceroSucursal(tercerousuarioid:any){
    let url = this.PATH + '/api/admin/destroyTerceroSucursal/'+tercerousuarioid;
    return this.http.get(url, { headers:this._key.head()}).map(resp => resp.json());
  }// .destroyTerceroSucursal(tercerousuarioid:any)

}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/usuarios/usuarios.service.ts